import axios from 'axios';
import { API_URL } from '../config/api';

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json'
    };
};

export const requestAccess = async (targetUserId) => {
    const response = await axios.post(`${API_URL}/panel-access/request`, { targetUserId }, { headers: getHeaders() });
    return response.data;
};

export const grantAccess = async (targetUserId) => {
    const response = await axios.post(`${API_URL}/panel-access/grant`, { targetUserId }, { headers: getHeaders() });
    return response.data;
};

export const getIncomingRequests = async () => {
    const response = await axios.get(`${API_URL}/panel-access/incoming`, { headers: getHeaders() });
    return response.data;
};

export const getOutgoingRequests = async () => {
    const response = await axios.get(`${API_URL}/panel-access/outgoing`, { headers: getHeaders() });
    return response.data;
};

export const getApprovedAccess = async () => {
    const response = await axios.get(`${API_URL}/panel-access/approved`, { headers: getHeaders() });
    return response.data;
};

export const getGrantedToUsers = async () => {
    const response = await axios.get(`${API_URL}/panel-access/granted`, { headers: getHeaders() });
    return response.data;
};

export const approveRequest = async (id) => {
    const response = await axios.put(`${API_URL}/panel-access/${id}/approve`, {}, { headers: getHeaders() });
    return response.data;
};

export const rejectRequest = async (id) => {
    const response = await axios.put(`${API_URL}/panel-access/${id}/reject`, {}, { headers: getHeaders() });
    return response.data;
};

export const revokeAccess = async (id) => {
    const response = await axios.put(`${API_URL}/panel-access/${id}/revoke`, {}, { headers: getHeaders() });
    return response.data;
};
